'use strict';

var processInclude = require('app_storefront_base/util');

$(document).ready(function () {
    processInclude(require('app_schuurman/components/opt-in-form'));
});
